import { getServerUri } from "./uriUtility";

// Subscription changes the server computes itself. The client never sends a
// subscription back — it names the company (and, for usage, the counters).

function postCompany(servicePath, params) {
  return fetch(getServerUri(servicePath), {
    method: "POST",
    headers: { "content-type": "application/x-www-form-urlencoded" },
    body: new URLSearchParams({
      accessToken: localStorage.getItem("session.accessToken"),
      ...params,
    }),
  }).then((response) =>
    response.status === 200
      ? response.json()
      : response.text().then((text) => {
        throw new Error(`${servicePath} failed: ${text}`);
      })
  );
}

/** Starts the next subscription period if the current one has ended. Resolves to the company. */
export function rolloverCompanySubscription(companyID) {
  return postCompany("company/rolloverSubscription", { companyID: String(companyID) });
}

/**
 * Raises usage counters on the company's current period, e.g.
 * { monthlyCreatedPlayables: 3 }. Resolves to the updated company.
 */
export function incrementCompanyUsage(companyID, counters) {
  return postCompany("company/incrementUsage", {
    companyID: String(companyID),
    counters: JSON.stringify(counters),
  });
}
